import { render } from "./ModalAddAplicacao.vue?vue&type=template&id=7556b6bf"
import script from "./ModalAddAplicacao.vue?vue&type=script&lang=js"
export * from "./ModalAddAplicacao.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__